import React from 'react';
import './CompContentBlock.css';

const CompContentBlock = ({ heading, subheading, children }) => {
    return (
        <div className='uxi-comp-content-block-outer-container'>
            <div className='uxi-comp-content-block-inner-container'>
                <h2>{heading}</h2>
                {subheading && <h3>{subheading}</h3>}
                {children}
            </div>
        </div>
    );
};

export default CompContentBlock;
